<div class="segment flex">
  <ng-content></ng-content>
</div>
